/** Helpers for the company-portal clients list API (PROLINE-2492). */

import { splitPhoneForApi } from "../TeamsPermissions/employeeMappers";

/** Pagination meta from response headers (axios lowercases header keys). */
export const getCompanyClientsListMeta = (response) => ({
  currentPage: Number(response?.headers?.["current-page"] || 1),
  count: Number(response?.headers?.["total-count"] || 0),
  pages: Number(response?.headers?.["total-pages"] || 1),
});

/** Build list query params for server-side name search and pagination. */
export const buildCompanyClientsListParams = ({ search, page, pageSize }) => {
  const params = { page, items: pageSize };
  const term = (search || "").trim();
  if (term) {
    params.name = term;
  }
  return params;
};

/** Build PATCH body for updating a company-client relationship. */
export const buildUpdateCompanyClientPayload = ({
  name,
  phone,
  phoneCountryDialCode,
}) => {
  const data = { name: String(name ?? "").trim() };

  const { dial_code, phone_number } = splitPhoneForApi(
    phone,
    phoneCountryDialCode,
  );
  data.phone_number = phone_number || null;
  data.dial_code = phone_number ? dial_code : null;

  return data;
};

/** Build create-client body. Email is sent as `client_email` per API contract. */
export const buildCreateCompanyClientPayload = ({
  name,
  email,
  phone,
  phoneCountryDialCode,
}) => {
  const data = {
    name: String(name ?? "").trim(),
    client_email: String(email ?? "").trim(),
  };

  const { dial_code, phone_number: national } = splitPhoneForApi(
    phone,
    phoneCountryDialCode,
  );
  if (national) {
    data.phone_number = national;
    data.dial_code = dial_code;
  }

  return data;
};
